import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cross from '~/assets/icons/cross.svg';
import discount from '~/assets/icons/discount.svg';
import { playSound, Sound } from '~/assets/sounds';
import { setModalOfferVisible, useLayoutDispatch } from '../../redux';
import { TextLabel } from '../TextLabel';
import {
	StyledBackground,
	StyledBackgroundWrapper,
	StyledCloseButton,
	StyledContainer,
	StyledContentContainer,
	StyledControlsButton,
	StyledControlsContainer,
	StyledDiscountBannerContainer,
	StyledDot,
	StyledDotsContainer,
	StyledModalWrapper,
	StyledOfferNameContainer,
	StyledTopContainer,
	StyledViewButton,
} from './ModalOffer.styled';

const ModalOffer = () => {
	const dispatch = useLayoutDispatch();

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<SwitchTransition>
					<CSSTransition
						timeout={500}
						classNames="container"
						key={1}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
					>
						<StyledContentContainer>
							<StyledTopContainer>
								<TextLabel>Уникальные предложения</TextLabel>
								<StyledCloseButton
									onClick={() => {
										dispatch(setModalOfferVisible(false));
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								>
									<img src={cross} />
								</StyledCloseButton>
							</StyledTopContainer>
							<StyledBackgroundWrapper>
								<StyledBackground />
								<StyledDiscountBannerContainer>
									<img src={discount} />
									<TextLabel>
										Распродажа наборов с скидкой до{' '}
										<span style={{ fontWeight: 500 }}>50%!</span>
									</TextLabel>
								</StyledDiscountBannerContainer>
								<StyledOfferNameContainer>
									<TextLabel style={{ fontSize: 22 }}>
										<span style={{ fontWeight: 700 }}>BMW M4 CSL</span>{' '}
										<span style={{ fontWeight: 300, opacity: 0.5 }}>x</span>{' '}
										<span style={{ fontWeight: 700 }}>BMW M3 CS</span>
									</TextLabel>
									<TextLabel style={{ fontSize: 16, opacity: 0.5 }}>
										Уникальный винил + Красные детали
									</TextLabel>
								</StyledOfferNameContainer>
							</StyledBackgroundWrapper>
							<StyledViewButton
								onMouseEnter={() => playSound(Sound.LinkCursor)}
								onClick={() => {
									playSound(Sound.ClickButton);
								}}
							>
								Узнать подробнее
							</StyledViewButton>
						</StyledContentContainer>
					</CSSTransition>
				</SwitchTransition>
				<StyledControlsContainer>
					<StyledControlsButton
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						onClick={() => {
							playSound(Sound.ClickButton);
						}}
					>
						Назад
					</StyledControlsButton>
					<StyledDotsContainer>
						<StyledDot
							onMouseEnter={() => playSound(Sound.LinkCursor)}
							$selected
						/>
						<StyledDot
							onMouseEnter={() => playSound(Sound.LinkCursor)}
							onClick={() => {
								playSound(Sound.ClickButton);
							}}
						/>
						<StyledDot
							onMouseEnter={() => playSound(Sound.LinkCursor)}
							onClick={() => {
								playSound(Sound.ClickButton);
							}}
						/>
						<StyledDot
							onMouseEnter={() => playSound(Sound.LinkCursor)}
							onClick={() => {
								playSound(Sound.ClickButton);
							}}
						/>
						<StyledDot
							onMouseEnter={() => playSound(Sound.LinkCursor)}
							onClick={() => {
								playSound(Sound.ClickButton);
							}}
						/>
					</StyledDotsContainer>
					<StyledControlsButton
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						onClick={() => {
							playSound(Sound.ClickButton);
						}}
					>
						Далее
					</StyledControlsButton>
				</StyledControlsContainer>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { ModalOffer };
